module.exports = __webpack_public_path__ + "media/images/icons/docflix-logo-dark-1346a24f081340c8280037a8e31ddd96.svg";